import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=a10bcb84&"
import script from "./Default.vue?vue&type=script&lang=js&"
export * from "./Default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\public\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a10bcb84')) {
      api.createRecord('a10bcb84', component.options)
    } else {
      api.reload('a10bcb84', component.options)
    }
    module.hot.accept("./Default.vue?vue&type=template&id=a10bcb84&", function () {
      api.rerender('a10bcb84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TenantSpecific/Default.vue"
export default component.exports